import { createThunkRequest, POST } from '@webapp/account/src/libs/request';

import type { Link } from '@webapp/common/entities/link';

import type { LinkResponse } from './map';
import { mapLink, mapValue } from './map';

export const getLinkParamsList = createThunkRequest(
    'links/getList',
    async (surveyId: number) => {
        const { list } = await POST('list/link_params', {
            survey: surveyId,
        });
        const links: Array<Link> = list.map(mapLink);
        const values = await Promise.all(
            list.map((item: LinkResponse) =>
                POST('get/link_values', {
                    paramId: item.ID,
                }),
            ),
        );
        return links.map((link: Link, idx: number) => ({ ...link, values: values[idx].values.map(mapValue) }));
    },
    { notify: false },
);

export const addLink = createThunkRequest(
    'links/addLink',
    async ({
        code,
        name,
        showInStats,
        surveyId,
        disallowRefilling,
    }: {
        name: string;
        surveyId: number;
        code: string;
        showInStats?: boolean;
        disallowRefilling?: boolean;
    }) => {
        const { id } = await POST('add/link_params', {
            survey_id: surveyId,
            title: name,
            name: code,
            hidden: !showInStats,
            disallowRefilling,
        });

        return {
            item: {
                id,
                code,
                name,
                showInStats,
                disallowRefilling,
            },
            message: 'Ссылка добавлена',
        };
    },
);

export const updateLink = createThunkRequest(
    'links/updateLink',
    async ({
        code,
        id,
        name,
        showInStats,
        disallowRefilling,
    }: {
        name: string;
        id: number;
        code: string;
        showInStats?: boolean;
        disallowRefilling?: boolean;
    }) => {
        await POST('change/link_params', {
            id,
            title: name,
            name: code,
            hidden: !showInStats,
            disallowRefilling: disallowRefilling,
        });

        return {
            id,
            code,
            message: 'Ссылка обновлена',
            name,
            editing: false,
            showInStats,
            disallowRefilling,
        };
    },
);

export const deleteLink = createThunkRequest(
    'links/deleteLink',

    async ({ id }: { id: number }) => {
        await POST('delete/link_params', {
            id,
        });
        return {
            id,
            message: 'Ссылка удалена',
        };
    },
);

export const updateLinkValues = createThunkRequest(
    'links/updateLinkValues',
    async (
        {
            surveyId,
            linkId,
            values,
        }: {
            surveyId: number;
            linkId: number;
            values: Array<string>;
        },
        { dispatch },
    ) => {
        await POST('change/link_values', {
            paramId: linkId,
            data: values,
        });
        dispatch(getLinkParamsList(surveyId));

        return {
            linkId,
            values,
        };
    },
);

export const getCsvWithLinks = createThunkRequest(
    'links/getCsvWithLinks',
    async (surveyId: number) => {
        const resp = await POST('get/link_csv', {
            surveyId,
        });
        window.open(resp.file.link);
        return resp;
    },
    { notify: false },
);
